import analytics from '../analytics/analytics';
export const updatePennyDebugger = (submitChatMessagesPayload, chatMessages, headers) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const indexedDB = window.indexedDB;
    const openRequest = indexedDB.open('PennyDB', 2);
    openRequest.onupgradeneeded = function (event) {
      // @ts-ignore
      const db = event.target.result;
      if (!db.objectStoreNames.contains('PennyDBStore')) {
        const objectStore = db.createObjectStore('PennyDBStore');
        objectStore.createIndex('pblb', 'pblb', {
          unique: false
        });
      }
    };
    openRequest.onsuccess = function (e) {
      var _a;
      // @ts-ignore
      const db = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result;
      if (db) {
        db.onerror = function (event) {
          analytics.log({
            source: 'updatePennyDebugger',
            message: `Error occurred in writing data ${event.target.errorCode}`
          });
        };
        const transaction = db.transaction(['PennyDBStore'], 'readwrite');
        const objectStore = transaction.objectStore('PennyDBStore');
        const request = objectStore.put({
          data: {
            submitChatMessagesPayload,
            chatMessages,
            headers
          }
        }, 'pblb');
        request.onsuccess = function (e) {
          analytics.log({
            source: 'updatePennyDebugger',
            message: 'Data has been written successfully'
          });
        };
        request.onerror = function (e) {
          analytics.log({
            source: 'updatePennyDebugger',
            message: `Error occurred in writing data ${e}`
          });
        };
      }
    };
    openRequest.onerror = function (e) {
      analytics.log({
        source: 'updatePennyDebugger',
        message: `Error occurred in opening database ' ${e}`
      });
    };
  } catch (e) {
    analytics.log({
      source: 'updatePennyDebugger',
      message: `Error occurred in opening database ' ${e}`
    });
  }
};